import { FieldQueryInternalControl, FieldQueryItem, FieldQueryPredefinedControl, FieldQueryPredefinedControlType } from "./field-query.types";

type GetProcessedControlsParams = {
  onItemMove: (direction: "up" | "down") => void;
  selectedItemId?: FieldQueryItem["id"];
  items: FieldQueryItem[];
  onAllItemsRemove: () => void;
  controls: Array<FieldQueryPredefinedControl>;
};

export const getProcessedControls = ({
  onItemMove,
  onAllItemsRemove,
  items,
  selectedItemId,
  controls,
}: GetProcessedControlsParams): Array<FieldQueryInternalControl> => {
  const predefinedActionsConfig: Record<FieldQueryPredefinedControlType, { config: FieldQueryInternalControl }> = {
    [FieldQueryPredefinedControlType.moveUp]: {
      config: {
        handler: () => onItemMove("up"),
        iconSrc: "png/arrow_up.png",
        description: "move-up-condition",
        tooltip: "Move field up",
        disabled: false,
      },
    },
    [FieldQueryPredefinedControlType.moveDown]: {
      config: {
        handler: () => onItemMove("down"),
        iconSrc: "png/arrow_down.png",
        description: "move-down-condition",
        tooltip: "Move field down",
        disabled: false,
      },
    },
    [FieldQueryPredefinedControlType.removeAll]: {
      config: {
        handler: () => {
          // Only execute if there are items to remove
          if (items.length > 0) {
            onAllItemsRemove();
          }
        },
        iconSrc: "png/remove_all.png",
        description: "remove-all-conditions",
        tooltip: "Erase all fields",
        disabled: false,
      },
    },
  };

  return controls
    .map(({ type, handler, ...otherProps }) => {
      if (type && predefinedActionsConfig[type]) {
        const config = predefinedActionsConfig[type].config;
        return {
          ...config,
          ...otherProps,
          // Ensure tooltip is always set from config
          tooltip: config.tooltip || "",
        } as FieldQueryInternalControl;
      }
      return null;
    })
    .filter((control): control is FieldQueryInternalControl => control !== null);
};
